import { storeToRefs, useGtmTrackEvent } from '#imports'
import { useGuestStore } from '~/store/guest'

export const useEmployeeGtmTrackEvent = () => {
  const guestStore = useGuestStore()
  const { guest, currentGift } = storeToRefs(guestStore)

  return useGtmTrackEvent({
    partnerId: currentGift.value?.partnerId,
    zenniId: guest.value?.userId,
    giftCatalog:
      currentGift.value?.catalog?.[0] ||
      currentGift.value?.policy?.catalogs?.[0] ||
      guest.value?.store?.currentCatalog ||
      '',
  })
}
